// extracted by mini-css-extract-plugin
export default {"commentList":"commentList_commentList__+aMok"};